class VideoPlayOnVisible {
  constructor($element) {
    this.$element = $element;

    this.setVars();
    this.bindObservers();
  }

  bindObservers() {
    const options = {
      rootMargin: '0px',
      threshold: 0.75,
    };

    const observer = new IntersectionObserver( (entries, observer) => {
      this.isVisible = entries[0]?.isIntersecting;
      this.render();

      if (this.isVisible) {
        observer.unobserve(this.$element);
      }
    }, options);

    observer.observe(this.$element);
  }

  render() {
    if (this.isVisible && !this.didPlay) {
      this.$element.play();
      this.didPlay = true;
    }
  }

  setVars() {
    this.didPlay = false;
    this.isVisible = false;
  }
}

document.querySelectorAll('video[data-play-on-visible="true"]').forEach(($element) => {
  new VideoPlayOnVisible($element);
});
